/**Dependencies */
import React, { useEffect, useRef, useState } from "react";
// import Slider from "react-slick";

/**Components */
import { CardCarrousel } from "../components/CardCarrousel";
import { Row, Col, Card, Badge, Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { settings } from "../utils";
import { CarouselCards } from "../components/CarouselCards";
import { PrincipalBanner } from "../components/PrincipalBanner";
import { Swiper, SwiperSlide } from "swiper/react";
import Slider from "react-slick";
import { BannerDudas } from "../components/BannerDudas";

/**Images */
import imgSirenis from "../images/img-sirenis.png";
import imgRoyalton from "../images/img-royalton.png";
import imgRiu from "../images/img-riu.png";
import imgCar1 from "../images2/Traslados_modelo1.png";
import imgCar2 from "../images2/Traslados_modelo2.png";
import bannerTraslado1 from "../images2/Banner_traslado_1.png";
import bannerTraslado2 from "../images2/Banner_traslado_2.png";
import dinkColletion from "../images2/Dink-coleccion.png";
import spiritualColletion from "../images2/Spiritual-coleccion.png";
import adventureCollection from "../images2/Adventure-coleccion.png";
import loveCollection from "../images2/Love-coleccion.png";
import bussinesCollection from "../images2/Business-coleccion.png";
import ecoCollection from "../images2/Eco-coleccion.png";
import bannerAclaraDudas from "../images2/banner-aclara-dudas.png";
import bannerAclaraDudasMovil from "../images2/banner-aclara-dudas-movil.png";
import { FaShoppingBag } from "react-icons/fa";
import { IoMdPeople, IoMdPerson } from "react-icons/io";
import { TfiTimer } from "react-icons/tfi";

/**Styles */
import "../styles/transportation.scss";
import { getTrasladosDisponibilidad } from "../services/searchService";
import Swal from "sweetalert2";
import { getActivePDP } from "../services/checkoutService";
import { carruselDestinos } from "../services/carruselesService";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Currency,
  FormatCancellationPolicies,
  FormatDate,
  FormatHours,
  totalPrices,
} from "../helpers";
import { CheckOutCart } from "../components/CheckOutCart";
import { Navigation } from "swiper/modules";
import { Loader } from "../components/Loader";
import { CarruselHotels } from "../components/CarruselHotels";
import { comisionUser } from "../services/LoginService";
import { getCollections } from "../services/CollectionsService";
import Skeleton from "react-loading-skeleton";

/**
 * Componente principal de la sección de Traslados
 *
 * Muestra una banner principal, una sección de vehículos con sus características,
 * una sección de colecciones de hoteles y una sección de dudas.
 *
 * @returns {JSX.Element} El componente principal de la sección de Traslados
 */
export const Traslados = () => {
  const [comisionUsuario, setComisionUsuario] = useState(0);
  const [userData] = useState(
    JSON.parse(localStorage.getItem("dataUser") || 0)
  );
  const arrBanner = [
    {
      image: bannerTraslado1,
    },
    {
      image: bannerTraslado2,
    },
  ];

  const [vehicules] = useState([
    { imgVehicule: imgCar2, type: "Compartido", suitcase: "1", maxPax: "7" },
    { imgVehicule: imgCar1, type: "Privado", suitcase: "4", maxPax: "4" },
    { imgVehicule: imgCar2, type: "Compartido", suitcase: "7", maxPax: "7" },
    { imgVehicule: imgCar1, type: "Privado", suitcase: "7", maxPax: "7" },
  ]);
  const [destinies] = useState([
    {
      hotel: "Grand Sirenis Punta Cana Resort & Aquagame",
      location: "Punta Cana, Rep. Dom",
      price: "$000,000",
      days: "10",
      img: imgSirenis,
    },
    {
      hotel: "Grand Sirenis Punta Cana Resort & Aquagame",
      location: "Punta Cana, Rep. Dom",
      price: "$000,000",
      days: "10",
      img: imgRoyalton,
    },
    {
      hotel: "Grand Sirenis Punta Cana Resort & Aquagame",
      location: "Punta Cana, Rep. Dom",
      price: "$000,000",
      days: "10",
      img: imgRiu,
    },
  ]);

  const cardsColecciones = [
    {
      title: "Dink",
      img: dinkColletion,
      btnText: "Descubre más",
      category: "dink",
    },
    {
      title: "Spiritual",
      img: spiritualColletion,
      btnText: "Descubre más",
      category: "spiritual",
    },
    {
      title: "Adventure",
      img: adventureCollection,
      btnText: "Descubre más",
      category: "adventure",
    },
    {
      title: "Love",
      img: loveCollection,
      btnText: "Descubre más",
      category: "love",
    },
    {
      title: "Business",
      img: bussinesCollection,
      btnText: "Descubre más",
      category: "business",
    },
    {
      title: "Eco",
      img: ecoCollection,
      btnText: "Descubre más",
      category: "eco",
    },
  ];
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [destinos, setDestinos] = useState([]);
  const [pdp, setPdp] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [traslados, setTraslados] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true); // Indicador de carga
  const [collections, setCollections] = useState([]);
  const [modalData, setModalData] = useState([]);
  const [arrSession, setArrSession] = useState(
    JSON.parse(sessionStorage.getItem("datosReserva")) || []
  );
  const trasRef = useRef(null);

  const [arrivalDeparture, setArrivalDeparture] = useState(
    arrSession?.traslados?.length === 2 && params.get("departure")
      ? "DEPARTURE"
      : "ARRIVAL"
  );
  const navigate = useNavigate();
  const handleClose = () => setShow(false);
  const handleShow = (data) => {
    setShow(true);
    setModalData(data);
  };

  let typeTravel = "";

  useEffect(() => {
    const comision = async () => {
      try {
        if (userData?.usuario?.id) {
          const response = await comisionUser(userData?.usuario?.id);
          setComisionUsuario(response);
        } else {
          setComisionUsuario(0);
        }
      } catch (error) {
        throw new Error("error connection: " + error);
      }
    };

    comision();
  }, []);

  useEffect(() => {
    const obtenerCollections = async () => {
      try {
        const response = await getCollections();
        setCollections(response);
      } catch (error) {
        throw new Error("Error fetching Data. Destinations: " + error);
      }
    };
    obtenerCollections();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchCarruselDestinos = async () => {
      const response = await carruselDestinos(1);
      return response;
    };
    const fetchHoteles = async () => {
      const response = await fetchCarruselDestinos();
      setDestinos(response);
    };
    fetchHoteles();
  }, []);

  useEffect(() => {
    const pasarelaActiva = async () => {
      try {
        const pasarela = await getPdp();
        setPdp(pasarela);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    pasarelaActiva();
  }, []);
  const getPdp = async () => {
    try {
      const response = await getActivePDP();
      return response;
    } catch (error) {
      console.error("Error fetching rates:", error);
      return [];
    }
  };

  const actualizarDatosTras = (
    infoVehicules,
    rateKey,
    tipoTraslado,
    tipoViaje,
    tipoVehiculo,
    destino,
    origen,
    fechaViaje,
    horaViaje,
    precio,
    precioApi,
    api,
    cancellationText,
    codedestino,
    observaciones
  ) => {
    sessionStorage.removeItem("datosReservaPP");
    const ahora = new Date();
    let fechaExpiracion;

    const datosPrevios = JSON.parse(sessionStorage.getItem("datosReserva")) || {
      hospedaje: [],
      actividades: [],
      traslados: [],
    };

    if (datosPrevios?.traslados?.length === 0) {
      // Primera habitación: 30 minutos desde ahora
      fechaExpiracion = new Date(ahora.getTime() + 5 * 60 * 1000);
    } else {
      // Usar la fecha de expiración existente de la primera habitación
      fechaExpiracion = new Date(datosPrevios?.traslados[0].fechaExpiracion);
    }

    // Crear un array de habitaciones a agregar
    const nuevosTraslados = {
      transferData: infoVehicules,
      codigo_pais: params.get("country"),
      rateKey: rateKey,
      tipo:
        params.get("typeTransfer") === "A"
          ? "FLIGHT"
          : params.get("typeTransfer") === "P"
          ? "CRUISE"
          : params.get("typeTransfer") === "T"
          ? "TRAIN"
          : "N/A",
      tipoTraslado: tipoTraslado,
      tipoViaje: tipoViaje,
      tipoVehiculo: tipoVehiculo,
      destino: destino,
      origen: origen,
      fechaViaje: fechaViaje + horaViaje,
      precioApi: precioApi,
      precio: precio,
      api: api,
      numAdultos: paxes?.[0],
      numMenores: paxes?.[1],
      numInfantes: paxes?.[2],
      edadesMenores: 0,
      cancellationText: cancellationText,
      codedestino: codedestino,
      checkIn: params.get("arrival").split("T")[0],
      checkOut: params.get("departure")
        ? params.get("departure").split("T")[0]
        : params.get("arrival").split("T")[0],
      observacionesTraslados: observaciones,
      fechaExpiracion: fechaExpiracion.toISOString(), // Misma para todas
      dataSearch: traslados?.data?.search?.occupancy,
    };

    if (
      datosPrevios?.traslados?.length == 1 &&
      params.get("typeTraslado") == "haciaAe"
    ) {
      Swal.fire({
        title: "Máximo de Traslados",
        text: "Solo se puede agregar un traslado por reservación.",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Continuar con la reservación",
        cancelButtonText: "Cancelar este traslado",
        denyButtonText: "Reemplazar traslado",
        customClass: {
          confirmButton: "btn-purple w-auto",
          denyButton: "btn-purple w-auto",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          // Continuar con la reservación
          navigate("/preventa");
          setTimeout(() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
          }, 200);
        } else if (result.isDenied) {
          // Crear una copia del array actual
          let nuevoTraslado = [...datosPrevios.traslados];

          // Reemplazar la última habitación con la nueva
          nuevoTraslado[nuevoTraslado.length - 1] = Array.isArray(
            nuevosTraslados
          )
            ? nuevosTraslados[0] // Extrae el primer objeto si es un array
            : nuevosTraslados;

          // Guardar en sessionStorage
          const setDatos = {
            idPasarela: pdp?.nombre,
            hospedaje: datosPrevios?.hospedaje,
            actividades: datosPrevios?.actividades,
            traslados: nuevoTraslado,
          };

          sessionStorage.setItem("datosReserva", JSON.stringify(setDatos));
          window.dispatchEvent(new CustomEvent("cartUpdated"));
          window.dispatchEvent(new CustomEvent("sessionStorageUpdated"));
          // Actualizar el estado global en React
          setShowAlert(true);
          setArrSession(setDatos);
        }
      });
      return;
    } else if (
      params.get("typeTraslado") == "desdeAe" &&
      datosPrevios?.traslados?.length == 2
    ) {
      Swal.fire({
        title: "Máximo de Traslados",
        text: "Haz seleccionado tu salida y llegada. Solo se pueden agregar dos traslados por reservación.",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Continuar con la reservación",
        cancelButtonText: "Cancelar este traslado",
        denyButtonText: "Reemplazar traslado",
        customClass: {
          confirmButton: "btn-purple w-auto",
          denyButton: "btn-purple w-auto",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          // Continuar con la reservación
          navigate("/preventa");
          setTimeout(() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
          }, 200);
        } else if (result.isDenied) {
          // Crear una copia del array actual
          let nuevoTraslado = [...datosPrevios.traslados];

          // Reemplazar la última habitación con la nueva
          nuevoTraslado[nuevoTraslado.length - 1] = Array.isArray(
            nuevosTraslados
          )
            ? nuevosTraslados[0] // Extrae el primer objeto si es un array
            : nuevosTraslados;

          // Guardar en sessionStorage
          const setDatos = {
            idPasarela: pdp?.nombre,
            hospedaje: datosPrevios?.hospedaje,
            actividades: datosPrevios?.actividades,
            traslados: nuevoTraslado,
          };

          sessionStorage.setItem("datosReserva", JSON.stringify(setDatos));
          window.dispatchEvent(new CustomEvent("cartUpdated"));
          window.dispatchEvent(new CustomEvent("sessionStorageUpdated"));
          // Actualizar el estado global en React
          setShowAlert(true);
          setArrSession(setDatos);
        }
      });
      return;
    } else if (
      params.get("typeTraslado") == "desdeAe" &&
      datosPrevios?.traslados?.length == 1 &&
      !params.get("departure")
    ) {
      Swal.fire({
        title: "Máximo de Traslados",
        text: "Solo se pueden agregar un traslado por reservación.",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Continuar con la reservación",
        cancelButtonText: "Cancelar este traslado",
        denyButtonText: "Reemplazar traslado",
        customClass: {
          confirmButton: "btn-purple w-auto",
          denyButton: "btn-purple w-auto",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          // Continuar con la reservación
          navigate("/preventa");
          setTimeout(() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
          }, 200);
        } else if (result.isDenied) {
          // Crear una copia del array actual
          let nuevoTraslado = [...datosPrevios.traslados];

          // Reemplazar la última habitación con la nueva
          nuevoTraslado[nuevoTraslado.length - 1] = Array.isArray(
            nuevosTraslados
          )
            ? nuevosTraslados[0] // Extrae el primer objeto si es un array
            : nuevosTraslados;

          // Guardar en sessionStorage
          const setDatos = {
            idPasarela: pdp?.nombre,
            hospedaje: datosPrevios?.hospedaje,
            actividades: datosPrevios?.actividades,
            traslados: nuevoTraslado,
          };

          sessionStorage.setItem("datosReserva", JSON.stringify(setDatos));
          window.dispatchEvent(new CustomEvent("cartUpdated"));
          window.dispatchEvent(new CustomEvent("sessionStorageUpdated"));
          // Actualizar el estado global en React
          setShowAlert(true);
          setArrSession(setDatos);
        }
      });
      return;
    } else {
      // Agregar nuevas habitaciones correctamente
      const nuevoTraslado = [...datosPrevios.traslados, nuevosTraslados];

      // Guardar en sessionStorage
      const setDatos = {
        idPasarela: pdp?.nombre,
        hospedaje: datosPrevios?.hospedaje,
        actividades: datosPrevios?.actividades,
        traslados: nuevoTraslado,
      };

      sessionStorage.setItem("datosReserva", JSON.stringify(setDatos));
      window.dispatchEvent(new CustomEvent("cartUpdated"));
      window.dispatchEvent(new CustomEvent("sessionStorageUpdated"));
      if (params.get("departure") && datosPrevios?.traslados?.length === 0) {
        Swal.fire({
          title: "Haz seleccionado tu traslado de llegada.",
          text: "Por favor selecciona tu traslado de salida.",
          showDenyButton: false,
          showCancelButton: false,
          showConfirmButton: false,
          timer: 3000,
        }).then(() => {
          setLoading(true);
          setTimeout(() => {
            setLoading(false);
            setArrivalDeparture("DEPARTURE");
          }, 3000);
        });
      } else if (
        params.get("departure") &&
        datosPrevios?.traslados?.length === 1
      ) {
        Swal.fire({
          title: "Haz seleccionado tu traslado de salida.",
          text: "Puedes continuar con tu reserva o reemplazar tu traslado de salida.",
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: "Ir al Carrito",
          cancelButtonText: "Seguir buscando",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/preventa");
            setTimeout(() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }, 200);
          }
        });
      }

      // Actualizar el estado global en React

      setShowAlert(true);
      setArrSession(setDatos);
    }
  };

  if (params.get("typeTraslado") === "desdeAe") {
    typeTravel = {
      from: {
        codigo: params.get("from"),
        tipo: params.get("typeTransfer"),
      },
      to: {
        codigo: params.get("to"),
        tipo: params.get("typeHotel"),
      },
    };
  } else if (params.get("typeTraslado") === "haciaAe") {
    typeTravel = {
      from: {
        codigo: params.get("from"),
        tipo: params.get("typeHotel"),
      },
      to: {
        codigo: params.get("to"),
        tipo: params.get("typeTransfer"),
      },
    };
  }

  const paxes = params?.get("pax")?.split("|");

  const request = {
    language: params.get("lang"),
    ...typeTravel,
    arrival: params.get("arrival"),
    departure: params.get("departure") ? params.get("departure") : "",
    adults: paxes?.[0],
    childrens: paxes?.[1],
    infants: paxes?.[2],
  };

  useEffect(() => {
    const getTraslados = async () => {
      try {
        const response = await trasladosDisponibility();
        setTraslados(response);
      } catch (error) {
        throw new Error("error connection", error);
      }
    };
    getTraslados();
  }, [location.search]);
  const trasladosDisponibility = async () => {
    setLoading(true);

    try {
      const response = await getTrasladosDisponibilidad(request);
      setLoading(false);

      return response;
    } catch (error) {
      setLoading(false);

      console.error("Error fetching rates:", error);
      return [];
    }
  };
  useEffect(() => {
    if (traslados?.data?.services?.length > 0 && trasRef.current) {
      trasRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [traslados]);

  const trasladosFiltrados = traslados?.data?.services?.filter(
    params.get("typeTraslado") === "desdeAe" && params.get("departure")
      ? (info) => info?.direction === arrivalDeparture
      : (info) => info?.direction
  );

  const direccionTitulo =
    trasladosFiltrados?.[0]?.direction === "DEPARTURE"
      ? "salida"
      : trasladosFiltrados?.[0]?.direction === "ARRIVAL"
      ? "llegada"
      : trasladosFiltrados?.[0]?.direction;

  return (
    <>
      {loading && <Loader />}
      <PrincipalBanner idSeccion={4} principalTitle="Vamos a donde vayas" />
      <div
        ref={trasRef}
        className="container py-5 carousel-container-selector-traslados"
      >
        {trasladosFiltrados?.length > 0 && (
          <h1 className="text-center pb-1 section-cards-traslados">
            Elige tu traslado de{" "}
            <span bg="secondary" className="text-nowrap w-auto">
              {direccionTitulo}
            </span>
          </h1>
        )}

        {/* <h1 className="text-center pb-1 section-cards-traslados">Traslados cómodos y seguros</h1> */}
        {/* <Swiper
          pagination={{
            clickable: true,
          }}
          spaceBetween={20}
          direction={"vertical"}
          breakpoints={{
            300: {
              slidesPerView: 1,
            },
            1024: {
              slidesPerView: 2,
            },
            1400: {
              slidesPerView: 3,
            },
          }}
          className="swiper"
        > */}
        {traslados?.data?.services?.length > 0 ? (
          <>
            {traslados?.data?.services
              ?.filter(
                params.get("typeTraslado") === "desdeAe" &&
                  params.get("departure")
                  ? (info) => info?.direction === arrivalDeparture
                  : (info) => info?.direction
              )
              ?.map((infoVehicule, index) => {
                let politicasText = "";
                infoVehicule?.cancellationPolicies?.forEach((policy) => {
                  politicasText += `<strong>Fecha de cancelación:</strong> ${FormatCancellationPolicies(
                    policy?.from
                  )} <br/>
                  <strong>Monto de penalidad:</strong> ${Currency(
                    policy?.amount
                  )} MXN <br/>`;
                });
                return (
                  <>
                    {/* <SwiperSlide key={index + 1}> */}
                    <div
                      key={index + 1}
                      className="cards-hotels container mb-4"
                    >
                      <Card className="shadow border-0 rounded-4">
                        <Row>
                          <Col lg={4} md={12} sm={12}>
                            <img
                              src={infoVehicule?.content?.images[0]?.url}
                              alt=""
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                              }}
                            />
                          </Col>
                          {/* <Col lg={4} md={12} sm={12}> */}
                          <div className="pt-5 d-flex justify-content-center d-lg-none d-md-none d-block">
                            <Button
                              className="btn-blue rounded-5 p-2 d-block d-lg-none"
                              style={{ width: "12rem" }}
                              onClick={() =>
                                actualizarDatosTras(
                                  infoVehicule,
                                  infoVehicule?.rateKey,
                                  infoVehicule?.direction,
                                  infoVehicule?.transferType,
                                  infoVehicule?.vehicle?.name,
                                  infoVehicule?.pickupInformation?.to
                                    ?.description,
                                  infoVehicule?.pickupInformation?.from
                                    ?.description,
                                  infoVehicule?.pickupInformation?.date
                                    ? FormatDate(
                                        infoVehicule?.pickupInformation?.date
                                      )
                                    : "",
                                  infoVehicule?.pickupInformation?.time
                                    ? " - " +
                                        FormatHours(
                                          infoVehicule?.pickupInformation?.time
                                        )
                                    : "",
                                  totalPrices(
                                    infoVehicule?.price?.totalAmount,
                                    traslados?.markup?.markup,
                                    0,
                                    comisionUsuario?.traslados
                                  )[1],
                                  infoVehicule?.price?.totalAmount,
                                  "bol",
                                  politicasText,
                                  params.get("typeTraslado") === "desdeAe"
                                    ? params.get("from")
                                    : params.get("to"),
                                  infoVehicule?.content?.transferRemarks?.[0]
                                    ?.mandatory === true
                                    ? infoVehicule?.content
                                        ?.transferRemarks?.[0]?.description
                                    : ""
                                )
                              }
                            >
                              Seleccionar traslado
                            </Button>
                          </div>
                          {/* </Col> */}
                          <Col
                            lg={4}
                            md={12}
                            sm={12}
                            style={{ padding: "25px" }}
                          >
                            <div className="name-transportation pt-4 d-lg-flex d-grid justify-content-between">
                              <Row>
                                <Col lg={12}>
                                  <h4 className="fw-semibold">
                                    {infoVehicule?.transferType === "SHARED"
                                      ? "COMPARTIDO"
                                      : infoVehicule?.transferType === "PRIVATE"
                                      ? "PRIVADO"
                                      : infoVehicule?.transferType}{" "}
                                  </h4>
                                </Col>
                                <Col lg={6} xs={6}>
                                  <div className="d-transportation-badges">
                                    <span
                                      bg="secondary"
                                      className="text-nowrap w-auto"
                                      style={{
                                        //backgroundColor: "gray",
                                        color: "#3864ab",
                                      }}
                                    >
                                      {infoVehicule?.vehicle?.name} -{" "}
                                      {infoVehicule?.direction === "DEPARTURE"
                                        ? "SALIDA"
                                        : infoVehicule?.direction === "ARRIVAL"
                                        ? "LLEGADA"
                                        : infoVehicule?.direction}
                                    </span>
                                    <span
                                      bg="light"
                                      className="text-nowrap badge-transportation-m ligth"
                                      style={{
                                        color: "#3864ab",
                                      }}
                                    >
                                      {infoVehicule?.category?.name}
                                    </span>
                                  </div>
                                </Col>
                                {/* <Col lg={6} xs={6}>
                                  
                                </Col> */}
                              </Row>
                              <div
                                className="d-flex"
                                style={{ marginLeft: "6px" }}
                              ></div>
                              <div></div>
                            </div>
                            <div className="amenities pt-0 pt-sm-0 pt-lg-4">
                              {/* <br /> */}
                              <span
                                style={{
                                  color: "#3864ab",
                                }}
                              >
                                <IoMdPeople />
                                {
                                  infoVehicule?.content?.transferDetailInfo?.[2]
                                    ?.description
                                }{" "}
                              </span>
                              <br />
                              <span style={{ color: "#3864ab" }}>
                                <IoMdPerson />{" "}
                                {
                                  infoVehicule?.content?.transferDetailInfo?.[1]
                                    ?.description
                                }{" "}
                              </span>
                              <br />
                              <span style={{ color: "#3864ab" }}>
                                <TfiTimer /> Tiempo máximo de espera a la
                                llegada:{" "}
                                {
                                  infoVehicule?.content?.transferDetailInfo?.[0]
                                    ?.description
                                }
                              </span>{" "}
                            </div>
                            <div className="pt-2">
                              <Button
                                onClick={() => handleShow(infoVehicule)}
                                style={{
                                  color: "#3864ab",
                                  background: "transparent",
                                  border: "0",
                                  padding: "0",
                                }}
                              >
                                Descripción completa
                              </Button>
                            </div>
                          </Col>
                          <Col lg={4} md={12} sm={12} className="col-vehicule">
                            <div style={{ marginRight: "30px" }}>
                              <div className="py-0 py-sm-0 py-lg-4">
                                <h3
                                  className="fw-bold text-end"
                                  style={{ color: "rgb(57 100 171)" }}
                                >
                                  {comisionUsuario?.traslados && (
                                    <>
                                      <span
                                        style={{
                                          fontSize: "18px",
                                          color: "#8e8e8e",
                                          textDecoration: "line-through",
                                        }}
                                      >
                                        {Currency(
                                          totalPrices(
                                            infoVehicule?.price?.totalAmount,
                                            traslados?.markup?.markup,
                                            0
                                          )[1]
                                        )}{" "}
                                        MXN
                                      </span>
                                      <br />
                                    </>
                                  )}
                                  {Currency(
                                    totalPrices(
                                      infoVehicule?.price?.totalAmount,
                                      traslados?.markup?.markup,
                                      0,
                                      comisionUsuario?.traslados
                                    )[1]
                                  ) +
                                    " " +
                                    "MXN"}
                                </h3>
                                <p
                                  className="text-end"
                                  style={{ color: "#3864ab" }}
                                >
                                  Precio de{" "}
                                  <span
                                    bg="secondary"
                                    className="text-nowrap w-auto"
                                    style={{
                                      //backgroundColor: "gray",
                                      color: "#3864ab",
                                    }}
                                  >
                                    {infoVehicule?.direction === "DEPARTURE"
                                      ? "salida"
                                      : infoVehicule?.direction === "ARRIVAL"
                                      ? "llegada"
                                      : infoVehicule?.direction}
                                  </span>
                                  , para todos los <br /> viajeros
                                </p>
                              </div>
                              <div className="pt-5 d-flex justify-content-end">
                                <Button
                                  className="btn-blue rounded-5 p-2 d-sm-block d-none"
                                  style={{ width: "12rem" }}
                                  onClick={() =>
                                    actualizarDatosTras(
                                      infoVehicule,
                                      infoVehicule?.rateKey,
                                      infoVehicule?.direction,
                                      infoVehicule?.transferType,
                                      infoVehicule?.vehicle?.name,
                                      infoVehicule?.pickupInformation?.to
                                        ?.description,
                                      infoVehicule?.pickupInformation?.from
                                        ?.description,
                                      infoVehicule?.pickupInformation?.date
                                        ? FormatDate(
                                            infoVehicule?.pickupInformation
                                              ?.date
                                          )
                                        : "",
                                      infoVehicule?.pickupInformation?.time
                                        ? " - " +
                                            FormatHours(
                                              infoVehicule?.pickupInformation
                                                ?.time
                                            )
                                        : "",
                                      totalPrices(
                                        infoVehicule?.price?.totalAmount,
                                        traslados?.markup?.markup,
                                        0,
                                        comisionUsuario?.traslados
                                      )[1],
                                      infoVehicule?.price?.totalAmount,
                                      "bol",
                                      politicasText,
                                      params.get("typeTraslado") === "desdeAe"
                                        ? params.get("from")
                                        : params.get("to"),
                                      infoVehicule?.content
                                        ?.transferRemarks?.[0]?.mandatory ===
                                        true
                                        ? infoVehicule?.content
                                            ?.transferRemarks?.[0]?.description
                                        : ""
                                    )
                                  }
                                >
                                  Seleccionar traslado
                                </Button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Card>
                    </div>
                    {/* </SwiperSlide> */}
                  </>
                );
              })}
          </>
        ) : (
          <div className="text-center">
            {params.get("lang") ? (
              <>
                {!loading ? (
                  <h1 className="text-center">
                    No hay traslados disponibles. Intenta con otras fechas y
                    hora.
                  </h1>
                ) : (
                  <Skeleton height={30} width={400} />
                )}
              </>
            ) : (
              <h1 className="text-center pt-5">
                Encuentra los mejores traslados nacionales e internacionales
              </h1>
            )}
          </div>
        )}
        {/* </Swiper> */}
      </div>
      <Modal centered show={show} onHide={handleClose}>
        <Modal.Header className="justify-content-end p-2 pb-1">
          <Button
            variant="secondary"
            className=" m-0 rounded-circle"
            onClick={handleClose}
          >
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          <ul>
            <li>
              {modalData?.pickupInformation?.from?.type === "ATLAS"
                ? "Hotel: "
                : modalData?.pickupInformation?.from?.type === "IATA"
                ? "Aeropuerto: "
                : modalData?.pickupInformation?.from?.type === "PORT"
                ? "Puerto: "
                : modalData?.pickupInformation?.from?.type === "STATION"
                ? "Estación: "
                : ""}{" "}
              {modalData?.pickupInformation?.from?.description}
            </li>
            <li>
              {modalData?.pickupInformation?.to?.type === "ATLAS"
                ? "Hotel: "
                : modalData?.pickupInformation?.to?.type === "IATA"
                ? "Aeropuerto: "
                : modalData?.pickupInformation?.to?.type === "PORT"
                ? "Puerto: "
                : modalData?.pickupInformation?.to?.type === "STATION"
                ? "Estación: "
                : ""}{" "}
              {modalData?.pickupInformation?.to?.description}
            </li>
            <li>
              Fecha de{" "}
              {modalData?.direction === "DEPARTURE" ? "Salida" : "Llegada"}:{" "}
              {modalData?.pickupInformation?.date != null
                ? FormatDate(modalData?.pickupInformation?.date)
                : ""}
            </li>
            <li>
              Hora de{" "}
              {modalData?.direction === "DEPARTURE" ? "Salida" : "Llegada"}:{" "}
              {modalData?.pickupInformation?.time != null
                ? FormatHours(modalData?.pickupInformation?.time)
                : ""}
            </li>
          </ul>
          <ul className="border-top text-secondary pt-2 pb-2 m-0">
            <li>
              Adultos: {traslados?.data?.search?.occupancy?.adults}, Niños:{" "}
              {traslados?.data?.search?.occupancy?.children}, Infantes:{" "}
              {traslados?.data?.search?.occupancy?.infants}
            </li>
            <li>{modalData?.content?.transferDetailInfo?.[3]?.description}</li>
          </ul>
          <ul className="border-top text-secondary m-0 pt-2 pb-2">
            <li>Precio fijo, para todos los viajeros</li>
          </ul>
        </Modal.Body>
      </Modal>

      <CarouselCards
        title={"Encuentra más colecciones aquí"}
        cardsInfo={collections}
        seccion={"collections"}
      />
      <BannerDudas
        imgDudasDesk={bannerAclaraDudas}
        imgDudasMovil={bannerAclaraDudasMovil}
        bannerDudas={true}
      />
      <div className="section-cards-hotel container mb-5 py-5 py-sm-5 py-lg-5">
        <CarruselHotels idSeccion={5} idTitulo={4} />
      </div>
      <CheckOutCart
        arrDatos={arrSession}
        setAlert={setShowAlert}
        showAlert={showAlert}
        setAlertMessage={"Se agrego un nuevo traslado"}
        isCheckedBackTraslado={params.get("departure") ? true : false}
      />
    </>
  );
};
